/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AppGit = {
  /**
   * The connected GitHub repository, as "owner/repo".
   */
  repository: string;
  /**
   * The branch this app's deployments track.
   */
  defaultBranch?: string | undefined;
};

/** @internal */
export const AppGit$inboundSchema: z.ZodType<AppGit, z.ZodTypeDef, unknown> = z
  .object({
    repository: z.string(),
    defaultBranch: z.string().optional(),
  });

export function appGitFromJSON(
  jsonString: string,
): SafeParseResult<AppGit, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AppGit$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AppGit' from JSON`,
  );
}
